module.exports = "/_next/static/images/icon_1-834ff1b64fba9249045b235e82bc4b6c.svg";